module.exports = __webpack_public_path__ + "img/32xgmm.a12bfae5.svg";